// Entfernung zwischen zwei Punkten in Metern (Haversine-Formel)
export const distance = (point1, point2) => {
  const R = 6371000; // Earth radius in meters
  const lat1 = point1.lat * Math.PI / 180;
  const lat2 = point2.lat * Math.PI / 180;
  const deltaLat = (point2.lat - point1.lat) * Math.PI / 180;
  const deltaLng = (point2.lng - point1.lng) * Math.PI / 180;

  const a = Math.sin(deltaLat/2) * Math.sin(deltaLat/2) +
            Math.cos(lat1) * Math.cos(lat2) *
            Math.sin(deltaLng/2) * Math.sin(deltaLng/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

  return R * c;
};

// Gesamtlänge eines Linienzugs in Metern
export const pathLength = (points) =>
  points.reduce((sum, point, i) => (i === 0 ? 0 : sum + distance(points[i - 1], point)), 0);
